module.exports = "../../app/cells/components/modals/login_register_modal/login_modal.erb";